var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi:check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.8333 23.0848V25.0015C45.8308 29.4941 44.376 33.8654 41.6861 37.4636C38.9962 41.0619 35.2152 43.6942 30.907 44.968C26.5988 46.2418 21.9943 46.0888 17.7801 44.5319C13.566 42.975 9.96802 40.0976 7.52282 36.3287C5.07763 32.5599 3.91622 28.1016 4.21182 23.6188C4.50741 19.136 6.24417 14.8689 9.16307 11.4537C12.082 8.03863 16.0266 5.65855 20.4087 4.66848C24.7908 3.6784 29.3755 4.13138 33.4792 5.95984",
    stroke: "url(#paint0_linear_8417_185489)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.8333 8.33203L25 29.1862L18.75 22.9362",
    stroke: "url(#paint1_linear_8417_185489)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8417_185489",
    x1: 45.8333,
    y1: 24.9896,
    x2: 4.16666,
    y2: 24.9896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8417_185489",
    x1: 45.8333,
    y1: 18.7591,
    x2: 18.75,
    y2: 18.7591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.d55d424050f552e8277cfe9348762afc.svg";
export { ForwardRef as ReactComponent };